<template>
  <el-drawer
    :title="title"
    :visible.sync="showDrawer"
    :with-header="true"
    :size="drawerWidth"
    :wrapperClosable="false"
    :before-close="handleClose"
  >
    <section class="w-full px-6">
      <div class="">
        <div class="flex justify-between items-center mb-8">
          <div class="flex items-center">
            <button class="flex items-center" @click="updateCurrentStep(1)">
              <div
                class="w-6 h-6 flex justify-center items-center mr-3 rounded-full border-main w-fit text-xs"
                :class="[styleCardCreationStep('bg', 0)]"
              >
                1
              </div>
              <p
                :class="[styleCardCreationStep('text', 0)]"
                class="text-xs font-medium"
              >
                Create Card
              </p>
            </button>
          </div>
          <div class="hidden md:block w-4 h-0.5 border"></div>
          <div class="flex items-center">
            <button class="flex items-center" @click="updateCurrentStep(2)">
              <div
                class="w-6 h-6 flex justify-center items-center mr-3 rounded-full border-main w-fit text-xs"
                :class="[styleCardCreationStep('bg', 1)]"
              >
                2
              </div>
              <p
                :class="[styleCardCreationStep('text', 1)]"
                class="text-xs font-medium"
              >
                Billing Address
              </p>
            </button>
          </div>
          <div class="hidden md:block w-4 h-0.5 border"></div>
          <button class="flex items-center" @click="updateCurrentStep(3)">
            <div
              class="w-6 h-6 flex justify-center items-center mr-3 rounded-full border-main w-fit text-xs"
              :class="[styleCardCreationStep('bg', 2)]"
            >
              3
            </div>
            <p
              :class="[styleCardCreationStep('text', 2)]"
              class="text-xs font-medium"
            >
              Confirm
            </p>
          </button>
        </div>
        <create-card-form
          v-if="currentStepIsOne"
          :isDrawerUse="isDrawer"
          @updateCurrentStep="updateCurrentStep"
        />
        <billing-address-form
          v-if="currentStepIsTwo"
          :isDrawerUse="isDrawer"
          @updateCurrentStep="updateCurrentStep"
        />
        <confirm-card-details-form
          v-if="currentStepIsThree"
          :isDrawerUse="isDrawer"
          @cardCreationSuccess="handleCardCreationSuccess"
        />
      </div>
    </section>
  </el-drawer>
</template>
<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'CreateNewVirtualCardDrawer',
  props: {
    showDrawer: {
      type: Boolean,
      required: true
    }
  },
  components: {
    CreateCardForm: () =>
      import('@/components/v2/cards/forms/new-virtual-card/CreateCardForm.vue'),
    BillingAddressForm: () =>
      import(
        '@/components/v2/cards/forms/new-virtual-card/BillingAddressForm.vue'
      ),
    ConfirmCardDetailsForm: () =>
      import(
        '@/components/v2/cards/forms/new-virtual-card/ConfirmCardDetailsForm.vue'
      )
  },
  data () {
    return {
      isDrawer: true,
      showDialog: false,
      currentStep: this.$store.state.appTour.currentVirtualCardStep
    }
  },
  computed: {
    currentStepIsOne () {
      return this.currentStep === 1
    },
    currentStepIsTwo () {
      return this.currentStep === 2
    },
    currentStepIsThree () {
      return this.currentStep === 3
    },
    title () {
      return 'Add New Card'
    },
    drawerWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '100%'
    }
  },
  methods: {
    updateCurrentStep (value) {
      this.$store.dispatch(
        'appTour/updateCurrentVirtualCardCreationStep',
        value
      )
      this.currentStep = this.$store.state.appTour.currentVirtualCardStep
    },
    handleClose () {
      this.$emit('closeDrawer')
    },
    handleCardCreationSuccess () {
      this.$emit('openSuccessDialog')
    },
    styleCardCreationStep (item, step) {
      if (item === 'bg') {
        return this.currentStep > step
          ? 'bg-primary text-white'
          : 'bg-transparent text-fg-muted'
      } else {
        return this.currentStep > step ? 'text-black-10' : 'text-fg-muted'
      }
    }
  }
}
</script>
<style scoped>
>>> .el-drawer__header {
  color: var(--foreground-default);
  font-size: 0.9rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.3rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-main);
}
>>> .el-drawer {
  background: var(--background-surface) !important;
}
</style>
